/* 2026-09-16: 吸管取色（#6）—— 可见入口 + 桌面鼠标支持 + 目标自动分派
   ==================================================================
   背景（先前的两个毛病）：
     ① 取色只挂在设计画布的「触摸长按 550ms」（design-canvas.liquid 里的 eyedrop()），
        桌面端完全没有入口；
     ② 取到的色**只写进 #pfmDrawColorPicker**（画板弹窗里的颜色控件），而长按绑定的是
        #pfmCanvasInner（设计板画布，在画板弹窗后面）⇒ 在设计板里取色等于**零反馈**。
   做法：
     ① Actions 行新增可见按钮 #pfmPickBtn（.pfm-fbtn → 由 updateFloatToolbar() 自动随
        选中态置灰）；
     ② 本 asset 接管取色：进入拾取态 → 画布下一次点击 → 读像素 → 写进**当前对象对应的
        既有颜色控件**并派发 input（复用既有 apply 逻辑：文字走 applyTextControlsToActive，
        形状/文字填充走 setFill，描边走 setStyle）——**不写第二套应用逻辑**；
     ③ 暴露 window.__pfmPickApply(hex) 供 section 里的长按入口共用（一份实现，两个入口）。
   坐标系：getImageData 必须用**画布逻辑坐标**（contextContainer = 下层 canvas，逻辑分辨率）。
   ⚠️ 只能读到 fabric 下层画布 ⇒ 取不到产品底图（那是 DOM 层）。点在空白处 alpha≈0 → 明确提示。
*/
(function () {
  'use strict';
  var HEX = /^#[0-9a-f]{6}$/i;

  function CV() { return window.__pfmCanvas || null; }
  function wrapOf(c) { return (c && (c.wrapperEl || (c.getElement && c.getElement().parentNode))) || null; }
  function toast(m) { try { if (window.__pfmToast) window.__pfmToast(m); } catch (e) { } }

  /* 颜色控件是否真的可见（不能用 offsetParent：#pfmBoard 是 position:fixed） */
  function vis(id) {
    var el = document.getElementById(id);
    return (el && el.getClientRects && el.getClientRects().length) ? el : null;
  }

  /* 取色目标：按当前选中对象的类型自动分派到既有控件
     ⚠️ 顺序有讲究：填充面板（#pfmFillPanel）在**固定属性区**、对形状与文字都生效；
        而 #pfmTextColor 在 #panel-text 里，**只有 Text 标签页打开时才可见** ——
        若把它排在前面，用户选中文字（Text 页没开）时取色会直接失败。 */
  function target() {
    var c = CV(); if (!c) return null;
    var o = null;
    try { o = c.getActiveObject(); } catch (e) { }
    if (!o || o.isGrid) return null;
    var t = String(o.type || '').toLowerCase();
    if (t === 'line') {                       /* 线只有描边 */
      var so0 = vis('pfmVStroke');
      return so0 ? { el: so0, label: 'Stroke' } : null;
    }
    /* 位图不能像矢量那样改 fill —— 走「着色」：面板已开就直接写它的颜色控件，
       未开则退给 window.__hdImage.colorize()（它会打开面板）。 */
    if (t.indexOf('image') >= 0) {
      var cz = vis('pfmImgCzColor');
      if (cz) return { el: cz, label: 'Colorize' };
      if (window.__hdImage && window.__hdImage.colorize) return { api: 'colorize', label: 'Colorize' };
      return null;
    }
    var fa = vis('pfmVFillA');
    if (fa) return { el: fa, label: 'Fill' };
    if (t.indexOf('text') >= 0) {
      var tc = vis('pfmTextColor');           /* 兜底：填充面板不可见时的文字色 */
      if (tc) return { el: tc, label: 'Text color' };
    }
    var so = vis('pfmVStroke');
    if (so) return { el: so, label: 'Stroke' };
    return null;
  }

  /* ===== 唯一实现：把取到的色应用到当前对象（长按入口也走这里）===== */
  function apply(hex) {
    if (!HEX.test(hex || '')) return false;
    var tg = target();
    if (!tg) { toast('Select a text, shape or image first'); return false; }
    if (tg.api) {                     /* 经由既有 API 落地（当前仅图片着色） */
      var api = window.__hdImage && window.__hdImage[tg.api];
      var ok = false;
      try { ok = !!(api && api.call(window.__hdImage, hex)); } catch (e) { ok = false; }
      if (ok) toast(tg.label + ' → ' + hex.toUpperCase());
      return ok;
    }
    try {
      tg.el.value = hex;
      tg.el.dispatchEvent(new Event('input', { bubbles: true }));
    } catch (e) { return false; }
    /* 填充/描边这两种 input 处理链**自己不落快照**（applyFillToSelection 只渲染不入栈）
       → 这里显式补一次，保证「取色可撤销」。saveState 自带 300ms 防抖 + 栈顶去重。 */
    try { if (window.__pfmSaveState) window.__pfmSaveState(); } catch (e) { }
    toast(tg.label + ' → ' + hex.toUpperCase());
    return true;
  }
  window.__pfmPickApply = apply;

  /* ================= 拾取态 ================= */
  var picking = false, onDown = null, onEsc = null, savedCursor = null;

  function stop() {
    if (!picking) return;
    picking = false;
    if (onDown) { document.removeEventListener('pointerdown', onDown, true); onDown = null; }
    if (onEsc) { document.removeEventListener('keydown', onEsc, true); onEsc = null; }
    var c = CV(), wr = wrapOf(c);
    if (wr) wr.style.cursor = '';
    if (c && savedCursor) { c.hoverCursor = savedCursor.hover; c.defaultCursor = savedCursor.def; savedCursor = null; }
    var btn = document.getElementById('pfmPickBtn');
    if (btn) btn.classList.remove('on');
  }

  function hexAt(clientX, clientY) {
    var c = CV(), wr = wrapOf(c);
    if (!c || !wr) return null;
    var r = wr.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    if (clientX < r.left || clientX > r.right || clientY < r.top || clientY > r.bottom) return null;
    var x = Math.round((clientX - r.left) / r.width * c.getWidth());
    var y = Math.round((clientY - r.top) / r.height * c.getHeight());
    try {
      var d = c.contextContainer.getImageData(x, y, 1, 1).data;
      if (!d || d[3] <= 10) return null;
      return '#' + [d[0], d[1], d[2]].map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('');
    } catch (e) { return null; }
  }

  function start() {
    if (picking) { stop(); return; }
    if (!target()) { toast('Select a text, shape or image first'); return; }
    var c = CV(), wr = wrapOf(c);
    if (!wr) return;
    picking = true;
    try { savedCursor = { hover: c.hoverCursor, def: c.defaultCursor }; c.hoverCursor = 'crosshair'; c.defaultCursor = 'crosshair'; } catch (e) { savedCursor = null; }
    wr.style.cursor = 'crosshair';
    var btn = document.getElementById('pfmPickBtn'); if (btn) btn.classList.add('on');
    toast('Tap the canvas to pick a color');

    onEsc = function (e) { if (e.key === 'Escape') { stop(); toast('Pick cancelled'); } };
    /* 捕获阶段消费这次点击：既取色，也不让它穿到画布去做选中/取消选中 */
    onDown = function (e) {
      if (e.button && e.button !== 0) return;
      if (e.target && e.target.closest && e.target.closest('.pfm-fbtn')) { stop(); return; }
      e.preventDefault(); e.stopPropagation();
      var hex = hexAt(e.clientX, e.clientY);
      stop();
      if (hex) { if (!apply(hex)) toast('Nothing to color here'); }
      else toast('No color here');
    };
    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('keydown', onEsc, true);
  }

  function boot() {
    var btn = document.getElementById('pfmPickBtn');
    if (!btn || btn.__pickBound) return;
    btn.__pickBound = true;
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); start(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 1500);   /* board 后开也兜一次（幂等） */
})();
